import React, { Component, PropTypes as T } from 'react'
import { connect } from 'react-redux'

import { toggleMapDetails } from 'actions/search'

class SearchMapFeatured extends Component {
	getTimeFrom2400Hours( input ) {
		let hours = parseInt( input.substring( 0, 2 ), 10 )
		let am = hours > 11 ? 'pm' : 'am'
		hours = hours > 12 ? hours - 12 : hours
		let minutes = input.substring( 2 )

		let time = hours + ':' + minutes + am

		return time
	}

	getWeekday( n ) {
		let days = [
			'Sunday',
			'Monday',
			'Tuesday',
			'Wednesday',
			'Thursday',
			'Friday',
			'Saturday'
		]

		return days[ n ]
	}

	render() {
		const { selectedMarker } = this.props
		const wrapClassName = this.props.mapDetailsIsOpen ? 'is-open' : ''

		if ( ! selectedMarker ) {
			return (
				<div>
					<div className="-featured"></div>
					<div className="-church-details"></div>
				</div>
			)
		}

		var addressParts = []
		if ( selectedMarker.city ) addressParts.push( selectedMarker.city )
		if ( selectedMarker.region ) addressParts.push( selectedMarker.region )
		if ( selectedMarker.country ) addressParts.push( selectedMarker.country )
		const addressLine2 = addressParts.join( ', ' )

		const directionFull = selectedMarker.street_address + ', ' + selectedMarker.city + ', ' + selectedMarker.region + ', ' + selectedMarker.country
		const directionUrlPart = directionFull.replace( / /g, '+' )
		const suggestEditUrl = 'http://cloud.adventistchurch.com/suggestions/new?uuid=' + selectedMarker.uuid

		var timesMarkup = false
		var showTimes = false
		var languagesMarkup = false
		var showLanguages = false
		var clubsMarkup = false
		var showClubs = false
		var repsMarkup = false
		var showReps = false

		if ( selectedMarker && selectedMarker.times && selectedMarker.times.length ) {
			showTimes = true

			timesMarkup = selectedMarker.times.map( ( e, i ) => {
				const day = this.getWeekday( e.day_of_week )
				const startTime = this.getTimeFrom2400Hours( e.start_time )

				return (
					<div className="-time" key={ i }>
						<h5>{ day + ' ' + startTime }</h5>
						<p dangerouslySetInnerHTML={ { __html: e.name } }></p>
					</div>
				)
			} )
		}

		if ( selectedMarker && selectedMarker.languages && selectedMarker.languages.length ) {
			showLanguages = true

			languagesMarkup = selectedMarker.languages.map( ( e, i ) => {
				return (
					<span key={ i }>{ e }</span>
				)
			} )
		}

		if ( selectedMarker && selectedMarker.clubs && selectedMarker.clubs.length ) {
			showClubs = true

			clubsMarkup = selectedMarker.clubs.map( ( e, i ) => {
				return (
					<span key={ i }>{ e }</span>
				)
			} )
		}

		if ( selectedMarker && selectedMarker.representatives && selectedMarker.representatives.length ) {
			showReps = true

			repsMarkup = selectedMarker.representatives.map( ( e, i ) => {
				let icon = <i className="icon-user" aria-hidden="true"></i>

				if ( e.photo_url ) {
					icon = <img src={ e.photo_url } />
				}

				return (
					<div className="-rep" key={ i }>
						{ icon }

						<div>
							<span className="-rep-name">{ e.name }</span>
							<span className="-rep-title">{ e.job_title }</span>
						</div>
					</div>
				)
			} )
		}

		return (
			<div className={ '-map-details ' + wrapClassName }>
				<div className="-featured">
					<a href={ selectedMarker.site_url } className="-most-relevant" onClick={ ( e ) => { this.props.handleResultClick( e, selectedMarker.site_url ) } }>
						<div className="-most-relevant-item">
							<span className="-type">{ selectedMarker.type }</span>

							<h4 dangerouslySetInnerHTML={ { __html: selectedMarker.title } }></h4>
						</div>
					</a>

					<div className="-secondary">
						<span dangerouslySetInnerHTML={ { __html: selectedMarker.street_address } }></span>
						<span dangerouslySetInnerHTML={ { __html: addressLine2 } }></span>
						<span className="-directions-link"><a href={ 'https://www.google.com/maps/dir/Current+Location/' + directionUrlPart } target="_blank">Directions</a></span>

						<div className="-more" onClick={ this.props.handleMoreClick }>
							<i className="icon-angle-up" aria-hidden="true"></i>
						</div>
					</div>
				</div>

				<div className="-church-details">
					{ selectedMarker.photo_url &&
						<a href={ selectedMarker.site_url } className="-image" onClick={ ( e ) => { this.props.handleResultClick( e, selectedMarker.site_url ) } }>
							<img src={ selectedMarker.photo_url } alt="" />
						</a>
					}

					<div className="-text -text-a">
						{ timesMarkup }
					</div>

					<div className="-text -text-b">
						{ showLanguages &&
							<div className="-info -language-info">
								<i className="icon-language" aria-hidden="true"></i>

								<div>{ languagesMarkup }</div>
							</div>
						}

						{ showClubs &&
							<div className="-info -clubs-info">
								<i className="icon icon-campsite" aria-hidden="true"></i>

								<div>{ clubsMarkup }</div>
							</div>
						}

						<a href={ suggestEditUrl } className="-suggest-edit" target="_blank">Suggest an edit</a>
					</div>

					<div className="-text -text-c">
						{ showReps &&
							<div className="-reps">
								{ repsMarkup }
							</div>
						}
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		selectedMarker: state.search.selectedMarker,
		mapDetailsIsOpen: state.search.mapDetailsIsOpen
	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {
		handleMoreClick() {
			dispatch( toggleMapDetails() )
		}
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)( SearchMapFeatured )



// WEBPACK FOOTER //
// ./components/Search/SearchMapFeatured.jsx